import { cn, tailwind } from "@/utilities/tailwind-utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(tailwind.components.skeleton, className)}
      {...props}
    />
  );
}

export { Skeleton };
